module.exports = __webpack_public_path__ + "img/28_77.36c6e316.png";